export const formatNumber = (value: number | string): string | number => {
  if (!value) return value

  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}
